import PropTypes from 'prop-types';
import { multipleComponentIterator } from './MultipleComponentIterator.utils';
import { ComponentPropType } from '../../types/component';
export function multipleComponentIterationConfig() {
  return PropTypes.shape({
    component: ComponentPropType.isRequired,
    propMap: PropTypes.shape({}),
    children: PropTypes.arrayOf(multipleComponentIterationConfig)
  });
}
var propTypes = {
  iterator: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  components: PropTypes.arrayOf(multipleComponentIterationConfig()).isRequired,
  limit: PropTypes.number
};
var defaultProps = {
  limit: null
};
export default function MultipleComponentIterator(_ref) {
  var iterator = _ref.iterator,
    components = _ref.components,
    limit = _ref.limit;
  return multipleComponentIterator({
    iterator: iterator,
    components: components,
    limit: limit
  });
}
MultipleComponentIterator.propTypes = propTypes;
MultipleComponentIterator.defaultProps = defaultProps;